sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary, BlockBase) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var PersonalDetails = BlockBase.extend("com.reply.leaviosa.blocks.personalDetails.PersonalDetails", {
		metadata: {
			views: {
				Collapsed: {
					viewName: "com.reply.leaviosa.blocks.personalDetails.PersonalDetails",
					type: ViewType.XML
				},
				Expanded: {
					viewName: "com.reply.leaviosa.blocks.personalDetails.PersonalDetails",
					type: ViewType.XML
				}
			}
		}
	});
    
	return PersonalDetails;
});